import styled, { css } from 'styled-components';

import {
  MESSAGE_PADDING,
  MESSAGE_SIDEBAR_RIGHT_MARGIN,
  MESSAGE_SIDEBAR_WIDTH,
} from '@web/conversations/consts/layout';

// user avatar image widht & height
export const AVATAR_SIZE = 32;

export const MessageSidebar = styled.footer`
  display: flex;
  grid-area: sidebar;
`;

export const MessageWrapper = styled.div`
  grid-area: wrapper;
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  min-width: 0;
`;

type MessageLayoutProps = {
  hasError?: boolean;
  isActive?: boolean;
  isInteractive?: boolean;
};
export const MessageLayout = styled.div<MessageLayoutProps>`
  ${({ hasError, isActive, isInteractive, theme: { colors } }) =>
    hasError
      ? css`
          --bgColor: ${colors.danger}13;
          --hoverBgColor: var(--bgColor);
          --sidebarVisibility: unset;
        `
      : css`
          --bgColor: ${isActive ? colors.hoverBrand : 'transparent'};
          --hoverBgColor: ${isInteractive ? colors.hoverBrand : 'transparent'};
          --sidebarVisibility: ${isActive || !isInteractive ? 'unset' : 'none'};
        `};

  background-color: var(--bgColor);
  border-radius: 2px;
  display: grid;
  grid-template: 'sidebar wrapper' 1fr / ${MESSAGE_SIDEBAR_WIDTH}px 1fr;
  grid-column-gap: ${MESSAGE_SIDEBAR_RIGHT_MARGIN}px;
  padding: ${MESSAGE_PADDING}px;
  position: relative;

  &:hover {
    background-color: var(--hoverBgColor, --bgColor);
  }

  & ${MessageSidebar} {
    display: var(--sidebarVisibility);
  }

  &:hover ${MessageSidebar} {
    display: unset;
  }
`;

export const MessageAlternativeLayout = styled.div<MessageLayoutProps>`
  display: grid;
  grid-template: 'sidebar wrapper' minmax(${AVATAR_SIZE}px, 1fr) / ${MESSAGE_SIDEBAR_WIDTH}px 1fr;
  grid-column-gap: ${MESSAGE_SIDEBAR_RIGHT_MARGIN}px;
  margin-top: ${MESSAGE_PADDING * 3}px;
  padding: 0 ${MESSAGE_PADDING}px;
`;

export const MessageContextMenuWrapper = styled.div`
  bottom: 100%;
  margin-bottom: -5px;
  position: absolute;
  right: 0;
  z-index: 2;
`;

export const MessageInfoText = styled.div`
  color: ${({ theme }) => theme.colors.iconGray};
  font-size: 14px;
  font-style: italic;
`;
